import { totalRecordsLimit } from '@app/constants';

export const getLimitedPageCount = (
  totalRecords: number,
  recordsPerPage: number
) => Math.ceil(Math.min(totalRecords, totalRecordsLimit) / recordsPerPage);
